module.exports = __webpack_public_path__ + "static/media/icon-employee.8511cd89.svg";